/* @ngInject */

export default (
  $scope,
  $state,
  $timeout,
  webpage,
  documentService,
  mergeFieldsService,
  uiService,
  navigationService
) => {
  $scope.Model = {
    currentDocument: {},
    availableMergeFields: [],
    documentsList: null,
    mergeFields: [],
    isMergeFieldsVisible: false,
    watcher: null,
    isArchive: false,
    activeSection: 0,
    fields: [],
    mappableFields: [],
    isNew: false,
    isReady: false
  };

  webpage.pageTitle('Loading, please wait');

  mergeFieldsService.getFields(false).then((mergeFields) => {
    $scope.Model.availableMergeFields = mergeFields;
    documentService.readDocument({ id: $state.params.id }).then((data) => {
      $scope.Model.currentDocument = data;
      $scope.Model.mappableFields = data.pdfFields;
      $scope.Model.fields = data.fields;
      $scope.Model.isReady = true;
      webpage.pageTitle('Map PDF fields : Document templates : Settings');
    });
  });

  $scope.getProperty = (idx) => {
    const field = _.find($scope.Model.mappableFields || [], (f) => f?.id === idx);
    return field || '';
  };

  $scope.addProperty = (binding, property, pdfField) => {
    if (binding !== null) {
      const id = parseInt(binding.replace('property', '') || 0, 10);
      $scope.Model.mappableFields.push({
        id,
        name: property.name,
        mappableKey: property.key,
        originalKey: pdfField,
        type: property.type,
        weight: property.weight
      });
      $scope.Model.currentDocument.mappablFields = $scope.Model.mappableFields;
    }
  };

  $scope.deleteProperty = (property) => {
    $scope.Model.mappableFields.splice(_.indexOf($scope.Model.mappableFields, property), 1);
    $scope.Model.currentDocument.mappablFields = $scope.Model.mappableFields;
    documentService.updateDocument($scope.Model.currentDocument);
  };

  $scope.getName = (idx) => {
    const property = $scope.getProperty(idx);
    if (property) {
      const name = property.name.split(' - ');
      return `<span class="name-first-part">${name[0]} - ${name[1]}:</span><span class="name-second-part">${name[2]}</span>`;
    }
    return null;
  };

  $scope.getFieldValue = (key, idx) => $scope.Model.importData[idx][key];

  $scope.getFirstPartOfFieldName = (name, idx) => {
    const parts = name.split(' - ');
    return parts[idx];
  };

  $scope.divideTitle = (name) => {
    if (name) {
      const title = name.split(' - ');
      return `<span class="title-first-part">${title[0]} - ${title[1]}:</span><span class="title-second-part">${title[2]}</span>`;
    }
    return '<span class="title-first-part">N/A:</span><span class="title-second-part">N/A</span>';
  };
  $scope.previous = (section) => {
    $scope.Model.activeSection = section !== 0 ? section - 1 : section;
    if ($scope.Model.activeSection === 1) {
      $scope.Model.import.ticket = [];
      $scope.Model.import.person = [];
      $scope.Model.import.company = [];
    }
  };

  $scope.reloadState = () => {
    $state.reload();
  };

  $scope.back = ($event) => {
    $event.stopPropagation();
    navigationService.goToPreviousState();
  };

  $scope.save = ($event) => {
    $event.stopPropagation();
    documentService.updateDocument($scope.Model.currentDocument).then((response) => {
      if (response.status) {
        uiService.toast({
          text: {
            p1: 'Map fields',
            p2: 'saved',
            p3: 'successfully'
          }
        });
        navigationService.goToPreviousState();
      } else {
        uiService.toast({
          text: {
            p1: 'Failed to',
            p2: 'save',
            p3: 'your changes'
          },
          warn: true
        });
      }
    });
  };
};
